import { CatalogoSearchFilters } from '../../../../shared/catalogo/type/filter'
import { NeumaticosFilterValues } from '../api/neumaticosFiltro'

/** Sentinel del funnel mòbil (searchNeumaticosCardHome): «cap marca», no un id real. */
export function isValidSelectorMarcaId(
  marcaId: number | null | undefined
): marcaId is number {
  return marcaId != null && marcaId > 0
}

/** Resol la marca activa als filtres del catàleg (sidebar). */
export function resolveMarcaIdFromCatalogFilters(
  filters: CatalogoSearchFilters | undefined,
  fallbackMarcaId?: number | null,
  options?: { marcaFilterOptOut?: boolean }
): number | null {
  if (options?.marcaFilterOptOut) return null

  if (!filters || !('marca' in (filters as NeumaticosFilterValues))) {
    return isValidSelectorMarcaId(fallbackMarcaId) ? fallbackMarcaId : null
  }

  const marca = (filters as NeumaticosFilterValues).marca
  if (marca == null) {
    return isValidSelectorMarcaId(fallbackMarcaId) ? fallbackMarcaId : null
  }

  const ids = Array.isArray(marca) ? marca : [marca]
  if (ids.length === 0) return null

  const id = Number(ids[0])
  if (Number.isFinite(id) && id > 0) return id
  return isValidSelectorMarcaId(fallbackMarcaId) ? fallbackMarcaId : null
}

export function userClearedMarcaInCatalogFilters(
  catalogFilters: CatalogoSearchFilters | undefined
): boolean {
  return (
    catalogFilters != null &&
    'marca' in (catalogFilters as NeumaticosFilterValues) &&
    Array.isArray((catalogFilters as NeumaticosFilterValues).marca) &&
    ((catalogFilters as NeumaticosFilterValues).marca?.length ?? 0) === 0
  )
}

export function applyMarcaFilterToCatalogParams(
  mergedFilters: NeumaticosFilterValues,
  marcaId: number | null | undefined,
  catalogFilters: CatalogoSearchFilters | undefined,
  options?: { marcaFilterOptOut?: boolean }
): void {
  if (options?.marcaFilterOptOut) {
    delete mergedFilters.marca
    return
  }

  if (userClearedMarcaInCatalogFilters(catalogFilters)) {
    delete mergedFilters.marca
    return
  }

  if (Array.isArray(mergedFilters.marca)) {
    const validMarcaIds = mergedFilters.marca.filter(
      (id) => Number.isFinite(Number(id)) && Number(id) > 0
    )
    if (validMarcaIds.length === 0) delete mergedFilters.marca
    else mergedFilters.marca = validMarcaIds.map(String)
  }

  const hasMarcaFilter = Array.isArray(mergedFilters.marca)
    ? mergedFilters.marca.length > 0
    : mergedFilters.marca != null

  if (!hasMarcaFilter && isValidSelectorMarcaId(marcaId)) {
    mergedFilters.marca = [String(marcaId)]
  }
}
